import {Component, ElementRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
// import {StatusBarStyle} from '@capacitor/core';
//import {GoogleAnalytics} from '@awesome-cordova-plugins/google-analytics/ngx';

import {Observable, Subscription} from 'rxjs';
import {switchMap, take, tap} from 'rxjs/operators';
import {UnrApiService} from '../../core/api/api.service';
import {UnrUser} from '../../core/api/resources/unr-user.resource';
import {UnrAuthService} from '../../core/auth/auth.service';
import {AuthProviderId} from '../../core/auth/enum/auth-providers.enum';
import {KmOrMiles} from '../../core/enum/km-miles.enum';
import {StatusbarService} from '../../core/native/statusbar/statusbar.service';
import {UnrSettingsService} from '../../services/settings/settings.service';
import {MyRoutesStateService} from '../my-routes/my-routes.state.service';
import {UnrRouteListItem} from '../roadtrip-list/roadtrip-list-item/model/route-list-item.model';
import {AuthProvider} from '../../core/auth/enum/auth-provider';


import { User } from '@angular/fire/auth';

@Component({
  selector: 'unr-user-profile',
  templateUrl: 'profile.html',
  styleUrls: [
    'profile.scss'
  ]
})
export class UnrProfilePage {

  readonly APPLE_PLACEHOLDER = 'Apple Id User';

  @ViewChild('ionHeader', {static: false}) header: ElementRef;

  userPhotoUrl = '';
  name = '';
  fireBaseUserDetails: User;
  unrUserDetails: UnrUser;
  userSubscription: Subscription;
  menuItems = [
    {handler: this.goToTutorial.bind(this), icon: 'school', title: 'Tutorial', subtitle: 'How does unrestricted work?'},
    {handler: this.goToMyRoutes.bind(this), icon: 'map', title: 'My rides', subtitle: `Don't let those tyres get worn out.`},
    {handler: this.goToSettings.bind(this), icon: 'settings', title: 'Settings', subtitle: 'Personalize your journey.'},
    {handler: this.goToPrivacy.bind(this), icon: 'options', title: 'Compliance', subtitle: 'Privacy policy'}
  ];
  headerHeight = 0;
  authProvider: Observable<AuthProvider>;

  constructor(private settingsService: UnrSettingsService,
              private authService: UnrAuthService,
              private apiService: UnrApiService,
              private router: Router,
              //private googleAnalytics: GoogleAnalytics,
              private myRoutesStateService: MyRoutesStateService,
              private statusbarService: StatusbarService) {
    this.authProvider = this.authService.authProvider.asObservable();
  }

  getBgImage(): string {
  const baseUrl = window.location.hostname.includes('mrconceptual.online')
    ? 'https://mrconceptual.online/adeel_api/unristricted/assets/imgs/bg'
    : 'assets/imgs/bg';

  return `${baseUrl}/profile.jpg`;
}


  ionViewWillEnter(): void {
    this.statusbarService.changeStatusBar({ style: '' }, true);
    this.setBackGroundColor();
    //this.googleAnalytics.trackView('Profile Page');
    this.userSubscription = this.authService.getAuthState()
      .pipe(
        tap(user => {
          this.fireBaseUserDetails = user;
          this.userPhotoUrl = this.getOriginalSizeImageUrl(this.fireBaseUserDetails) || 'assets/icon/default-avatar.png';
          this.name = this.fireBaseUserDetails.displayName || this.fireBaseUserDetails.email;
          console.log({user});
        }),
        switchMap(() => this.settingsService.getKmOrMiles()),
        switchMap( (kmOrMiles: KmOrMiles) => this.apiService
          .getUserdetails(localStorage.getItem('uid'), kmOrMiles)
          .pipe(
            take(1)
          )
        ) 
      ).subscribe((user : any) => {
        console.log({user});
        this.unrUserDetails = user;
        this.userPhotoUrl= this.unrUserDetails.photoUrl || 'assets/icon/default-avatar.png';
      }, err => {
        console.log({err});
      });
  }

  ionViewWillLeave(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  setBackGroundColor(): void {
    const el = window.document.querySelector('page-profile');
    if (el) {
      el.setAttribute('style', 'background-color: white !important;');
    }
  }

  goToMyRoutes(): void {
    if (this.unrUserDetails.roadTrips) {
      const trips = this.unrUserDetails.roadTrips
        .map((roadTrip) => {
          return {
            iconName: roadTrip.label,
            details: roadTrip.description,
            country: roadTrip.country,
            distance: roadTrip.distance,
            imgPath: roadTrip.mainImageFile,
            title: roadTrip.tripName,
            id: roadTrip.id
          } as UnrRouteListItem;
        });
      this.myRoutesStateService.roadTrips = trips;
    }

    this.router.navigate(['my-routes']);
  }

  goToTutorial(): void {
    this.router.navigate(['tutorial']);
  }

  goToSettings(): void {
    this.router.navigate(['settings']);
  }

  goToPrivacy(): void {
    this.router.navigate(['privacy']);
  }

  private getOriginalSizeImageUrl(user: User): string {
    if (!user.providerData) {
      return;
    }
    switch (user.providerData[0].providerId) {
      case AuthProviderId.Facebook:
        return `https://graph.facebook.com/${user.providerData[0].uid}/picture?width=500`;
      case AuthProviderId.Google:
      default:
        return user.photoURL;
    }
  }
}
